__turbopack_context__.v({
  "buttons": "PairingWheelContent-module-scss-module__6TfVYG__buttons",
  "contentPanel": "PairingWheelContent-module-scss-module__6TfVYG__contentPanel",
  "contentShift": "PairingWheelContent-module-scss-module__6TfVYG__contentShift",
  "copy": "PairingWheelContent-module-scss-module__6TfVYG__copy",
  "eyebrow": "PairingWheelContent-module-scss-module__6TfVYG__eyebrow",
  "fade-in": "PairingWheelContent-module-scss-module__6TfVYG__fade-in",
  "headline": "PairingWheelContent-module-scss-module__6TfVYG__headline",
  "initial": "PairingWheelContent-module-scss-module__6TfVYG__initial",
  "isActive": "PairingWheelContent-module-scss-module__6TfVYG__isActive",
  "isInitial": "PairingWheelContent-module-scss-module__6TfVYG__isInitial",
  "isItemsActive": "PairingWheelContent-module-scss-module__6TfVYG__isItemsActive",
  "isSpinning": "PairingWheelContent-module-scss-module__6TfVYG__isSpinning",
  "isSpinsComplete": "PairingWheelContent-module-scss-module__6TfVYG__isSpinsComplete",
  "item": "PairingWheelContent-module-scss-module__6TfVYG__item",
  "progress": "PairingWheelContent-module-scss-module__6TfVYG__progress",
  "progressBar": "PairingWheelContent-module-scss-module__6TfVYG__progressBar",
  "progressBarFill": "PairingWheelContent-module-scss-module__6TfVYG__progressBarFill",
  "progressContent": "PairingWheelContent-module-scss-module__6TfVYG__progressContent",
  "progressText": "PairingWheelContent-module-scss-module__6TfVYG__progressText",
  "revealButtonIcon": "PairingWheelContent-module-scss-module__6TfVYG__revealButtonIcon",
  "revealContent": "PairingWheelContent-module-scss-module__6TfVYG__revealContent",
  "revealContentSurprise": "PairingWheelContent-module-scss-module__6TfVYG__revealContentSurprise",
  "revealContentText": "PairingWheelContent-module-scss-module__6TfVYG__revealContentText",
  "root": "PairingWheelContent-module-scss-module__6TfVYG__root",
  "spinning": "PairingWheelContent-module-scss-module__6TfVYG__spinning",
  "spinningHeadline": "PairingWheelContent-module-scss-module__6TfVYG__spinningHeadline",
  "spinningIcon": "PairingWheelContent-module-scss-module__6TfVYG__spinningIcon",
});
